import Typewriter from 'typewriter-effect';
import { motion } from 'framer-motion';

export const Hero = () => {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Animated background elements */}
      <motion.div 
        className="absolute inset-0 z-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ duration: 2 }}
      >
        <div className="grid-pattern"></div>
      </motion.div>

      <div className="text-center space-y-8 z-10 max-w-4xl px-4">
        {/* Main headline */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-cyan-400 neon-text mb-4">
            <Typewriter
              options={{
                strings: ['Welcome to HyperMesh AI'],
                autoStart: true,
                loop: false,
                cursor: '_',
                delay: 50,
                deleteSpeed: 9999999 // Effectively prevents deletion
              }}
            />
          </h1>
        </motion.div>

        {/* Subheadline */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
          className="space-y-4"
        >
          <div className="text-xl md:text-2xl lg:text-3xl text-gray-300">
            <Typewriter
              options={{
                strings: ['The Future of AI Automation is Here.'],
                autoStart: true,
                delay: 50,
                cursor: '|',
                loop: false,
                deleteSpeed: 9999999 // Effectively prevents deletion
              }}
            />
          </div>
          
          <div className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto glitch-text">
            Scale your business with AI-powered automation and skyrocket productivity
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.5, duration: 0.5 }}
          className="flex flex-col items-center space-y-4 mt-12"
        >
          <a
            href="https://calendly.com/hypermeshai/ai-consultation"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button text-lg md:text-xl font-semibold rounded group"
          >
            <span className="group-hover:hidden">&gt; Book a Free AI Consultation</span>
            <span className="hidden group-hover:inline">&gt; Schedule Now...</span>
          </a>
          
          <div className="text-sm text-gray-500 terminal-text">
            [System] AI automation ready for deployment_
          </div>
        </motion.div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3, duration: 1 }}
          className="grid grid-cols-2 md:grid-cols-3 gap-8 mt-16"
        >
          {[
            { label: 'Hours Saved', value: '25,000+' },
            { label: 'ROI Average', value: '200%' },
            { label: 'Reduction in Manual Workload', value: '70%' }
          ].map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="text-2xl md:text-3xl font-bold text-cyan-400 neon-text">{stat.value}</div>
              <div className="text-sm text-gray-400">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};